//React
import React, { useLayoutEffect,useEffect,useRef,useState } from 'react';
import { motion } from 'framer-motion';

//MATERIAL UI
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
// import ButtonGroup from '@mui/material/ButtonGroup';
//Icon
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

//Spinner
export const Spinner=()=>{
	return (
		<Grid container>
			<Grid size={12} sx={{ display:'flex',justifyContent:'center',alignItems:'center',height:'100vh' }}>
				<CircularProgress />
			</Grid>
		</Grid>
	);
};

const container = {
	hidden: {},
	visible: {
		transition: {
			staggerChildren: 0.04
		}
	}
};

const letter = {
	hidden: {
		opacity: 0,
		x: -12,
		filter: 'blur(6px)'
	},
	visible: {
		opacity: 1,
		x: 0,
		filter: 'blur(0px)',
		transition: {
			duration: 0.35,
			ease: 'easeOut'
		}
	}
};

export const RevealWord = ({ word, className }) => {
	return (
		<motion.p
			className={className}
			variants={container}
			initial='hidden'
			animate='visible'
			style={{ display: 'inline-flex' }}
		>
			{word.split('').map((char, i) => (
				<motion.span key={i} variants={letter}>
					{char === ' ' ? '\u00A0' : char}
				</motion.span>
			))}
		</motion.p>
	);
};

//Word Fade
export const WordFadeSequence = ({
	words = ['Creative', 'Powerful', 'Reliable'],
	reveal = 700,
	pause = 1600,
	hide = 500,
	className = ''
}) => {
	const [index, setIndex] = useState(0);
	const [visible, setVisible] = useState(true);
	const total = reveal + pause + hide; // FULL cycle time

	useEffect(() => {
		if (!words.length) return;

		let hideTimer;
		let nextTimer;

		// hide word
		hideTimer = setTimeout(() => {
			setVisible(false);
		}, reveal + pause);

		// next word
		nextTimer = setTimeout(() => {
			setIndex(prev => (prev + 1) % words.length);
			setVisible(true);
		}, total);

		return () => {
			clearTimeout(hideTimer);
			clearTimeout(nextTimer);
		};
	}, [index, words.length, reveal, pause, hide, total]);

	return (
		<div
			key={index}
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				overflow: 'hidden',
				'--cycle': `${total}ms`
			}}
			className=''
		>
			<span
				className={`wipeWord ${visible ? 'show' : 'hide'} ${className}`}
				style={{ '--reveal': `${reveal}ms` }}
			>
				{words[Number(index)]}
			</span>
		</div>
	);
};

export const ArrowButton = (props) => {
	const whiteBg = props?.bg === 'white';
	return(
		<Button
			sx={{
				position: 'relative',
				overflow: 'hidden',
				borderRadius: '50px',
				padding: '12px 40px',
				fontWeight: '1000',
				backgroundColor: whiteBg ? 'white' : '#5B31A1',
				color: whiteBg ? '#5B31A1' : '#fff',
				transition: 'color 0.4s ease',
				border: '5px solid',
				borderColor: whiteBg ? '#fff' : '#5B31A1',
				whiteSpace: 'nowrap',
				'&::before': {
					content: '" "',
					position: 'absolute',
					top: '-5px',
					bottom: '-5px',
					left: '-5px',
					right: '-5px',
					borderRadius: '50px 0 0 50px',
					background: whiteBg ? '#5B31A1' : '#fff',
					transform: 'scaleX(0)',
					transformOrigin: 'left',
					transition: 'transform 0.6s ease',
					zIndex: 0
				},
				// arrow
				'& .arrow': {
					position: 'absolute',
					top: '50%',
					left: 0,
					transform: 'translate(-100%, -52%)',
					fontSize: '23px',
					fontWeight: 1000,
					color: whiteBg ? '#fff' : '#5B31A1',
					transition: 'transform 0.6s ease',
					zIndex: 2
				},
				'& .arrowStat': {
					position: 'absolute',
					top: '50%',
					left: 0,
					transform: 'translate(90%, -52%)',
					fontSize: '23px',
					fontWeight: 1000,
					color: whiteBg ? '#5B31A1' : '#fff',
					transition: 'transform 0.6s ease',
					zIndex: 2
				},
				'&:hover::before': {
					transform: 'scaleX(1)'
				},
				'&:hover': {
					color: whiteBg ? '#fff' : '#5B31A1'
				},
				'&:hover .arrow': {
					transform: 'translate(calc(100% + 105px), -50%)'
				},
				'&:hover .arrowStat': {
					display: 'none'
				}
			}}
		>
			<ArrowForwardIcon className='arrowStat'/>
			<span style={{ position: 'relative', zIndex: 1 }}>{props.children}</span>
			<ArrowForwardIcon className='arrow' />
		</Button>
	);
};

//Custom Button
export const CustomButton = (props) => {
	const color = props.color;
	const bgcolor = props.bgcolor;
	return(
		<Button
			fullWidth
			endIcon={<ArrowForwardIcon className='font20' style={{ position: 'relative', zIndex: 1 }}/>}
			className='font18'
			onClick={props.onClick}
			sx={{
				whiteSpace: 'noWrap',
				py: '10px',
				justifyContent: 'space-between',
				borderRadius: '12px',
				position: 'relative',
				overflow: 'hidden',
				fontWeight: '500',
				backgroundColor: bgcolor || '#5B31A1',
				color: color || '#fff',
				transition: 'color 0.4s ease',
				border: '5px solid',
				borderColor: bgcolor || '#5B31A1',
				'&::before': {
					content: '" "',
					position: 'absolute',
					top: '-5px',
					bottom: '-5px',
					left: '-5px',
					right: '-5px',
					borderRadius: '12px 0 0 12px',
					background: color || '#fff',
					transform: 'scaleX(0)',
					transformOrigin: 'left',
					transition: 'transform 0.6s ease',
					zIndex: 0
				},
				'&:hover::before': {
					transform: 'scaleX(1)'
				},
				'&:hover': {
					color: bgcolor || '#5B31A1'
				}
			}}
		>
			<span style={{ position: 'relative', zIndex: 1 }}>{props.children}</span>
		</Button>
	);
};

// Title Animation 
export const AnimatedText = ({ title, hightLight, className, delay, animate }) => {

	const text = title || '';
	const highlightWords = hightLight || [];

	const sentence = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren:  0.08,
				delayChildren: delay ? 0.5 : 0
			}
		}
	};

	const blurWord = {
		hidden: {
			opacity: 0,
			filter: 'blur(14px)',
			x: 10,
			y: 30
		},
		visible: {
			opacity: 1,
			filter: 'blur(0px)',
			x: 0,
			y: 0,
			transition: {
				duration: 0.8,
				ease: [0.22, 1, 0.36, 1]
			}
		}
	};

	const lines = text.split('<br/>');

	return (
		<motion.p
			variants={sentence}
			initial='hidden'
			{...(animate
				? { animate }
				: { whileInView: 'visible', viewport: { once: true, margin: '-100px' } })}
			className={className}
		>
			{lines.map((line, lineIndex) => (
				<React.Fragment key={lineIndex}>
					{line.split(' ').map((w, i) => {
						// console.log(w, highlightWords);
						return(
							<motion.span
								key={`${lineIndex}-${i}`}
								variants={blurWord}
								className={highlightWords.includes(w) ? 'primaryCl' : ''}
								style={{ display: 'inline-block', marginRight: '8px' }}
							>
								{w}
							</motion.span>
						);
					})}
					{lineIndex !== lines.length - 1 && <br />}
				</React.Fragment>
			))}
		</motion.p>
	);
};

//Footer Logo Draw Animation
export const DrawTitle = ({ isView, isMobile }) => {
	const svgRef = useRef(null);
	const [ready, setReady] = useState(false);

	// important flags
	// const hasStartedSystem = useRef(false);
	const intervalRef = useRef(null);

	// prepare paths before paint
	useLayoutEffect(() => {
		const paths = svgRef.current.querySelectorAll('path');

		paths.forEach((path) => {
			const length = path.getTotalLength();
			path.style.strokeDasharray = length;
			path.style.strokeDashoffset = length;
			path.style.fill = 'none';
		});

		setReady(true);
	}, []);

	// animation runner
	const runAnimation = () => {
		const paths = svgRef.current.querySelectorAll('path');

		paths.forEach((path, i) => {
			const length = path.getTotalLength();

			// instant reset
			path.style.transition = 'none';
			path.style.strokeDashoffset = length;

			// force repaint
			path.getBoundingClientRect();

			// animate draw
			path.style.transition = `stroke-dashoffset 2.2s cubic-bezier(0.65, 0, 0.35, 1) ${i * 0.18}s`;
			path.style.strokeDashoffset = '0';
		});
	};

	useEffect(() => {
		// wait until svg ready and first viewport entry
		if (!isView || !ready) return;

		// already started? ignore isView forever
		// if (hasStartedSystem.current) return;

		// ---- BOOT THE SYSTEM (RUN ONLY ONCE EVER) ----
		// hasStartedSystem.current = true;

		// play immediately first time
		runAnimation();

		// start permanent 20s loop
		intervalRef.current = setInterval(() => {
			runAnimation();
		}, 10000);

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, [isView, ready]);

	return (
		<svg
			ref={svgRef}
			width={isMobile ? '1300' : '2600'}
			viewBox='0 0 900 200'
			xmlns='http://www.w3.org/2000/svg'
			className='drawTitle'
		>
			<defs>
				<linearGradient id='titleGradient' x1='0%' y1='0%' x2='0%' y2='100%'>
					<stop offset='0%' stopColor='#b9b9b9' />
					<stop offset='100%' stopColor='#242424' />
				</linearGradient>
			</defs>
			<path d='M27.5162 30.5804L19.0403 9.99184L11.9064 26.2153C11.443 26.9855 10.7251 27.5648 9.87982 27.8504C9.03457 28.136 8.1167 28.1094 7.28896 27.7754C6.68667 27.4779 6.17626 27.0194 5.81298 26.4494C5.44969 25.8795 5.24735 25.22 5.22787 24.5421L14.8143 1.9811C15.3882 1.3449 16.092 0.842615 16.8769 0.50902C17.6618 0.175424 18.509 0.0184803 19.3598 0.0491447C20.1391 0.104204 20.8993 0.318894 21.5942 0.680171C22.289 1.04145 22.9041 1.54181 23.4021 2.15087C30.7117 19.2555 35.9363 31.6555 36.9189 33.9835C37.1506 34.5413 37.7178 35.8993 37.1106 36.8451C36.4316 37.9121 34.6581 37.8959 33.9871 37.8878C30.544 37.8878 19.4956 37.8474 4.429 37.7747C3.55719 37.7644 2.71656 37.4448 2.05376 36.8716C1.39096 36.2984 0.948045 35.5081 0.802167 34.6383C0.77413 34.1062 0.855821 33.5741 1.04206 33.0758C1.2283 32.5774 1.515 32.1237 1.88393 31.7436C2.25286 31.3634 2.69592 31.0651 3.18497 30.8676C3.67402 30.6701 4.19835 30.5779 4.72458 30.5966C10.4338 30.5966 16.1564 30.5966 21.8922 30.5966L27.5162 30.5804Z' fill='#5B31A1'/>
			<path d='M180.323 30.5844L171.847 10.0073L164.745 26.2218C164.282 26.9915 163.564 27.5705 162.719 27.856C161.873 28.1414 160.955 28.1148 160.128 27.781C159.526 27.4823 159.017 27.0236 158.654 26.4543C158.291 25.885 158.088 25.2266 158.067 24.5495C161.262 17.036 164.458 9.51985 167.653 2.00102C168.227 1.36516 168.931 0.863161 169.716 0.529751C170.501 0.19634 171.348 0.0394837 172.199 0.0701311C172.978 0.12516 173.738 0.33973 174.433 0.700808C175.128 1.06189 175.743 1.56197 176.241 2.17069C183.55 19.2658 188.775 31.659 189.758 33.9857C189.989 34.5431 190.557 35.9004 189.949 36.8456C189.27 37.9121 187.497 37.8959 186.826 37.8878C183.383 37.8878 172.334 37.8474 157.268 37.7747C156.396 37.7645 155.555 37.445 154.893 36.8722C154.23 36.2993 153.787 35.5094 153.641 34.6401C153.613 34.1083 153.695 33.5765 153.881 33.0784C154.067 32.5804 154.354 32.1269 154.723 31.747C155.092 31.367 155.535 31.0689 156.024 30.8715C156.513 30.6742 157.037 30.5819 157.563 30.6006C163.278 30.6006 169 30.6006 174.731 30.6006L180.323 30.5844Z' fill='#5B31A1'/>
			<path d='M50.6109 25.2274C50.6109 28.4762 50.531 31.5462 50.6109 34.6407C50.7067 37.5321 49.0851 37.8894 46.7843 37.8894C44.4836 37.8894 43.3172 37.3372 43.3172 34.7544C43.3971 30.1655 43.3811 25.5685 43.3172 20.9471C43.3172 18.2507 44.6593 17.4628 47.0719 17.5034C51.7213 17.5684 56.3707 17.5034 61.0201 17.5034C64.2155 17.5034 66.9477 16.5938 67.0196 12.6303C67.0835 8.813 64.4872 7.41601 61.3237 7.2292C56.5305 6.96118 51.7373 6.95306 46.984 7.02616C44.5874 7.02616 43.3252 6.4008 43.2853 3.65559C43.2373 0.674846 44.6274 -0.0155185 47.2077 0.0494568C51.8491 0.171286 56.5065 0.0494291 61.1559 0.122526C67.8664 0.293087 72.4599 3.37132 73.8579 8.48001C75.5115 14.5308 73.6342 19.1441 67.4031 23.603C70.0952 27.9564 72.8194 32.3503 75.6873 36.996C73.4904 37.8082 70.5266 38.4336 67.9782 37.1098C63.4886 34.7707 64.2795 28.4193 59.7339 25.6254C58.0643 24.602 55.3002 23.8467 50.6109 25.2274Z' fill='#5B31A1'/>
			<path d='M140.268 15.4654C140.268 10.9518 140.38 7.11728 140.268 3.29071C140.164 0.606517 141.642 0.239023 143.775 0.278966C145.908 0.318909 147.482 0.478702 147.466 3.19485C147.418 13.692 147.418 24.189 147.466 34.6862C147.466 37.5541 145.708 37.8097 143.471 37.8816C141.075 37.8816 140.156 36.907 140.276 34.5184C140.396 30.8196 140.276 27.1209 140.276 23.0547H123.548C123.548 26.9851 123.444 30.8037 123.548 34.6143C123.635 37.0988 122.501 37.8976 120.216 37.8896C117.932 37.8816 116.302 37.5301 116.366 34.6941C116.47 29.5175 116.526 24.3089 116.366 19.1562C116.262 16.2563 117.516 15.4574 120.152 15.5134C125.193 15.6172 130.242 15.5134 135.291 15.5134L140.268 15.4654Z' fill='#5B31A1'/>
			<path d='M123.548 6.51849C123.548 7.7088 123.468 8.91511 123.548 10.0894C123.755 12.7177 122.238 13.1411 120.081 13.0932C118.051 13.0532 116.294 12.9654 116.406 10.2332C116.478 8.51567 116.486 6.7901 116.406 5.07254C116.278 2.36438 116.254 0.175514 120.144 0.207468C124.035 0.239423 123.62 2.50019 123.548 4.92875C123.54 5.46399 123.548 5.99123 123.548 6.51849Z' fill='#5B31A1'/>
			<path d='M98.1597 7.31278C98.1597 16.6116 98.0638 25.3512 98.2156 34.0828C98.2635 37.1025 97.1611 37.9573 94.2213 37.8854C91.5371 37.8215 90.8021 36.791 90.8261 34.2985C90.9113 24.0624 90.9113 13.8315 90.8261 3.60603C90.8261 1.30529 91.5291 0.0990249 94.0215 0.13098C98.4073 0.194889 102.809 0.226844 107.171 0.13098C109.791 0.0670703 110.215 1.49703 110.199 3.66196C110.183 5.82688 109.815 7.36073 107.219 7.32877C104.439 7.28084 101.635 7.31278 98.1597 7.31278Z' fill='#5B31A1'/>
			<path d='M83.3808 7.28135C80.6007 7.47308 78.8831 7.04967 78.8112 3.77431C78.7393 0.13947 80.8084 0.115531 83.3887 0.107543C85.969 0.0995541 87.6467 0.28328 87.6627 3.63852C87.6707 7.1775 85.8253 7.55296 83.3808 7.28135Z' fill='#5B31A1'/>
		</svg>
	);
};

//Input Label
export const InputLabel = ({ label, name }) => {

	const infoMsg = {
		sipFrequency: 'Indicates how often you make investments (e.g., daily, weekly, monthly, quarterly',
		sipAmount: 'the fixed monthly amount you plan to invest during your SIP',
		investmentPeriod: 'Investment period in Years',
		expectedReturn: 'The yearly growth rate you expect from your calculator investment'
	};

	return(
		<Stack direction='row' spacing={0.5} alignItems='center'>
			<Typography className='font15'>{label}</Typography>
			<Tooltip
				arrow={false}
				placement='top'
				disableInteractive
				title={
					<Box
						className='font13 fontBold'
						sx={{ bgcolor: '#fff', color: 'black', p: 1, borderRadius: '0px 5px 5px 0px', borderLeft: '3px solid #5B31A1', boxShadow: '5px 5px 15px 5px rgba(0,0,0,0.1)' }}
					>
						{infoMsg[String(name)]}
					</Box>
				}
				PopperProps={{
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [30, 0]
							}
						}
					]
				}}
				componentsProps={{
					tooltip: {
						sx: {
							backgroundColor: 'transparent',
							padding: 0,
							boxShadow: 'none',
							borderRadius: 0
						}
					}
				}}
			>
				<InfoOutlineIcon className='font16' style={{ color: 'grey' }}/>
			</Tooltip>
		</Stack>
	);
};
